import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import Button from '../../button';
import css from './new-modal.scss';
import CloseButton from '../../close-button/close-button';
import RankDropdown from '../../rank-dropdown/rank-dropdown';

const NewModal = ({ message, onClose, downloadCertificatesState, localeData, studentCertificatesGemCount }) => {
    const { isActive, downloadType } = downloadCertificatesState;
    const {
        title,
        buttons,
        content,
        label,
        dateRange,
        certificatesCount,
        retrievedGems,
        certificateType,
        isDownloadCertificateType
    } = message;
    let count = certificatesCount;
    let disableButton = false;

    if (studentCertificatesGemCount.selectedGems !== null) {
        count = studentCertificatesGemCount.selectedGems.resultCount;
        disableButton = count === 0;
    }

    return (
        <div className={css.component}>
            <div
                className={css.overlay}
                onClick={onClose}
                role="button"
                tabIndex="0"
            />
            <div className={css.container}>
                { isDownloadCertificateType ?
                    <div className={css.certificateTypeHeader}>
                        <h1>
                            {localeData['Label - Download']} {certificateType} {localeData['Label - Certificates']}
                        </h1>
                        <CloseButton onClose={onClose} className={css['close-button']} />
                    </div> :
                    <div className={css.header}>
                        {title && <h1>{title}</h1>}
                        <CloseButton onClose={onClose} className={css['close-button']} />
                    </div>
                }
                <div className={css.content}>
                    <div className={css.message}>{content}</div>
                    {isDownloadCertificateType &&
                    <div className={css['rank-dropdown-container']}>
                        <div className={css.dateRange}>{label} | {dateRange}</div>
                        <RankDropdown
                            certificatesCount={certificatesCount}
                            retrievedGems={retrievedGems}
                            localeData={localeData}
                        />
                    </div>
                    }
                    {buttons && (
                        <div className={css.buttons}>
                            {
                                buttons.map((item) => {
                                    const { title: btnTitle, icon, btnType, handler } = item;
                                    return (
                                        <Button
                                            key={_.uniqueId()}
                                            className={css.button}
                                            text={`${btnTitle} (${count})`}
                                            type={Button.LOZENGE}
                                            icon={icon || ''}
                                            alignIcon={Button.LEFT}
                                            hasSpinner={isActive && btnType === downloadType}
                                            btnType={btnType}
                                            disabled={disableButton || (isActive && btnType !== downloadType)}
                                            onClick={() => {
                                                if (handler) {
                                                    handler();
                                                } else {
                                                    onClose();
                                                }
                                            }}
                                        />
                                    ); /* end Button */
                                }) /* end buttons.map */
                            }
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

NewModal.propTypes = {
    onClose: PropTypes.func,
    message: PropTypes.shape({
        id: PropTypes.number,
        content: PropTypes.string,
        label: PropTypes.string,
        dateRange: PropTypes.string,
        certificatesCount: PropTypes.number,
        isDownloadCertificateType: PropTypes.bool,
        retrievedGems: PropTypes.arrayOf(PropTypes.shape({
            gem: PropTypes.number,
            count: PropTypes.number
        })),
        buttons: PropTypes.arrayOf(PropTypes.shape({
            title: PropTypes.string,
            handler: PropTypes.func,
            disabled: PropTypes.bool,
            icon: PropTypes.string
        }))
    }),
    downloadCertificatesState: PropTypes.object,
    localeData: PropTypes.object,
    studentCertificatesGemCount: PropTypes.object
};

function mapStateToProps(state) {
    return {
        downloadCertificatesState: state.downloadCertificatesState,
        localeData: state.localeData,
        studentCertificatesGemCount: state.studentCertificatesGemCount
    };
}

export default connect(mapStateToProps)(NewModal);



// WEBPACK FOOTER //
// ./components/modal/new-modal/new-modal.js